{
    "CAT-Exception-Quick-Search-Fields": [
        {
            "label": "Event Type", "columnname": "type", "placeholder": "Event Type",
            "width": "", "datatype": "Array", "isLarge": false, "preserveUserOptedValues": true
        },
        {
            "label": "Symbol", "columnname": "symbol", "placeholder": "Symbol",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Order ID", "columnname": "orderID", "placeholder": "Order ID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "Destination", "columnname": "destination", "placeholder": "Destination",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Firm Designated ID", "columnname": "firmDesignatedID", "placeholder": "Firm Designated ID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "GroupName", "columnname": "groupName", "placeholder": "GroupName",
            "width": "", "datatype": "String", "isLarge": false
        }
    ],
    "CAT-Exception-Grid-Columns": [
        {
            "display": "true",
            "ui_columnname": "action",
            "db_columnname": "modifiedFlag",
            "datatype": "char",
            "mappingkey": "modifiedFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "firm ROEID",
            "db_columnname": "firmROEID",
            "datatype": "String",
            "mappingkey": "firmROEID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "symbol",
            "db_columnname": "symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "type",
            "db_columnname": "type",
            "datatype": "String",
            "mappingkey": "type",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Date",
            "db_columnname": "reportDate",
            "datatype": "Date",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Group",
            "db_columnname": "groupName",
            "datatype": "String",
            "mappingkey": "groupName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "failure Code",
            "db_columnname": "failureCode",
            "datatype": "String",
            "mappingkey": "failureCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "failure Description",
            "db_columnname": "failureDescription",
            "datatype": "String",
            "mappingkey": "failureDescription",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Actual Value",
            "db_columnname": "actualValue",
            "datatype": "String",
            "mappingkey": "actualValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Suggested Value",
            "db_columnname": "suggestedValue",
            "datatype": "String",
            "mappingkey": "suggestedValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "order ID",
            "db_columnname": "orderID",
            "datatype": "String",
            "mappingkey": "orderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "order Date",
            "db_columnname": "orderKeyDate",
            "datatype": "String",
            "mappingkey": "orderKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Side",
            "db_columnname": "side",
            "datatype": "String",
            "mappingkey": "side",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Price",
            "db_columnname": "price",
            "datatype": "Float",
            "mappingkey": "price",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Quantity",
            "db_columnname": "quantity",
            "datatype": "Int",
            "mappingkey": "quantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "destination",
            "db_columnname": "destination",
            "datatype": "String",
            "mappingkey": "destination",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "routed Order ID",
            "db_columnname": "routedOrderID",
            "datatype": "String",
            "mappingkey": "routedOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Parent Order ID",
            "db_columnname": "parentOrderID",
            "datatype": "String",
            "mappingkey": "parentOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Parent Order Date",
            "db_columnname": "parentOrderKeyDate",
            "datatype": "String",
            "mappingkey": "parentOrderKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Allocation ID",
            "db_columnname": "allocationID",
            "datatype": "String",
            "mappingkey": "allocationID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "representativeInd",
            "db_columnname": "representativeInd",
            "datatype": "String",
            "mappingkey": "representativeInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Firm Designated ID",
            "db_columnname": "firmDesignatedID",
            "datatype": "String",
            "mappingkey": "firmDesignatedID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "routeRejectedFlag",
            "db_columnname": "routeRejectedFlag",
            "datatype": "Boolean",
            "mappingkey": "routeRejectedFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "solicitationFlag",
            "db_columnname": "solicitationFlag",
            "datatype": "Boolean",
            "mappingkey": "solicitationFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "session",
            "db_columnname": "session",
            "datatype": "String",
            "mappingkey": "session",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "trade Id",
            "db_columnname": "tradeId",
            "datatype": "String",
            "mappingkey": "tradeId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "quote Id",
            "db_columnname": "quoteId",
            "datatype": "String",
            "mappingkey": "quoteId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "quote MPID",
            "db_columnname": "quoteMPID",
            "datatype": "String",
            "mappingkey": "quoteMPID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "event Timestamp",
            "db_columnname": "eventTimestamp",
            "datatype": "String",
            "mappingkey": "eventTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "manual Flag",
            "db_columnname": "manualFlag",
            "datatype": "Boolean",
            "mappingkey": "manualFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Time In Force",
            "db_columnname": "timeInForce",
            "datatype": "String",
            "mappingkey": "timeInForce",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Sender IMID",
            "db_columnname": "senderIMID",
            "datatype": "String",
            "mappingkey": "senderIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Handlling Instructions",
            "db_columnname": "handlingInstructions",
            "datatype": "String",
            "mappingkey": "handlingInstructions",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "severity",
            "db_columnname": "severity",
            "datatype": "String",
            "mappingkey": "severity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CAT Submitter ID",
            "db_columnname": "CATSubmitterID",
            "datatype": "String",
            "mappingkey": "CATSubmitterID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CAT Reporter ID",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "file Name",
            "db_columnname": "fileName",
            "datatype": "String",
            "mappingkey": "fileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "status",
            "db_columnname": "status",
            "datatype": "String",
            "mappingkey": "status",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "buyOrderID",
            "db_columnname": "buyOrderID",
            "datatype": "String",
            "mappingkey": "buyOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "sellOrderID",
            "db_columnname": "sellOrderID",
            "datatype": "String",
            "mappingkey": "sellOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "clientOrderID",
            "db_columnname": "clientOrderID",
            "datatype": "String",
            "mappingkey": "clientOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "firmOrderID",
            "db_columnname": "firmOrderID",
            "datatype": "String",
            "mappingkey": "firmOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Action Type",
            "db_columnname": "actionType",
            "datatype": "String",
            "mappingkey": "actionType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "BFMMFlag",
            "db_columnname": "BFMMFlag",
            "datatype": "Boolean",
            "mappingkey": "BFMMFlag",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "create Date",
            "db_columnname": "createDate",
            "datatype": "String",
            "mappingkey": "createDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "last Update",
            "db_columnname": "lastUpdate",
            "datatype": "String",
            "mappingkey": "lastUpdate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "user",
            "db_columnname": "user",
            "datatype": "String",
            "mappingkey": "user",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Event Timestamp",
            "db_columnname": "EventTimestamp",
            "datatype": "String",
            "mappingkey": "EventTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": "",
            "excludeFromExport": "true",
            "field_info": "Please preserve (JSON Object Keys -> display | ui_columnname | db_columnname | mappingKey | excludeFromExport) this field forever as it is because EventTimeStamp field has been used for Default Date Filter in CAT-Exception Screen so we need to add one more invisible EventTimeStamp Field for User Extended Search"
        }
        
    ]
}